import { useRef, useState } from "react";

const DropdownBtn = ({
  text = "Receipt Actions",
  actions = [],
  onAction,
  className = "all-btn other-btn",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const handleActionClick = (action) => {
    if (disabled || action?.disabled) return;

    if (typeof action?.onClick === "function") {
      action.onClick(action);
    }

    if (typeof onAction === "function") {
      onAction(action);
    }

    setIsOpen(false);
  };

  const handleBlur = (e) => {
    if (!wrapperRef.current?.contains(e.relatedTarget)) {
      setIsOpen(false);
    }
  };

  return (
    <div
      ref={wrapperRef}
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => !disabled && setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onFocus={() => !disabled && setIsOpen(true)}
      onBlur={handleBlur}
    >
      <button
        type="button"
        className={className}
        aria-expanded={isOpen}
        aria-haspopup="menu"
        disabled={disabled}
      >
        {text}
      </button>

      {isOpen && actions.length > 0 && (
        <div className="dropdown-list" role="menu">
          {actions.map((action, index) => (
            <button
              key={action?.value || action?.label || index}
              type="button"
              role="menuitem"
              className="fancy-list-item"
              disabled={disabled || action?.disabled}
              onClick={() => handleActionClick(action)}
              style={{
                border: "none",
                textAlign: "left",
                width: "100%",
              }}
            >
              {action?.label || "Unnamed action"}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownBtn;
